import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  consumeMobileHandoffSessionMarker,
  MOBILE_HANDOFF_QUERY_PARAM,
  MOBILE_HANDOFF_QUERY_VALUE,
  restoreMobileHandoffSessionMarker,
} from '@/consts/mobileHandoff.consts';

export function useMobileHandoffActivation(activate: () => Promise<void>, enabled: boolean): void {
  const [searchParams, setSearchParams] = useSearchParams();
  const hasStartedRef = useRef(false);
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (
      !enabled ||
      hasStartedRef.current ||
      searchParams.get(MOBILE_HANDOFF_QUERY_PARAM) !== MOBILE_HANDOFF_QUERY_VALUE
    ) {
      return;
    }

    const originalSearchParams = new URLSearchParams(searchParams);
    const remainingSearchParams = new URLSearchParams(searchParams);
    remainingSearchParams.delete(MOBILE_HANDOFF_QUERY_PARAM);
    setSearchParams(remainingSearchParams, { replace: true });

    if (!consumeMobileHandoffSessionMarker()) {
      return;
    }

    hasStartedRef.current = true;
    void activate().catch(() => {
      if (isMountedRef.current) {
        restoreMobileHandoffSessionMarker();
        setSearchParams(originalSearchParams, { replace: true });
      }
    });
  }, [activate, enabled, searchParams, setSearchParams]);
}
